import {getFormConfig as getHeadFormConfig} from './formDataConfig'
import {isCanShowBlock} from "../../../../../../utils";

export const formConfig = vm => {
  let arr =  getHeadFormConfig(vm).filterFormConfig
  let configArr = arr.filter(item => item.tabGroup && isCanShowBlock('dataInfo',item.showBlock));

  let thead = [], common = [];

  configArr.forEach(item => {
    if (!thead.includes(item.tabGroup)) {
      thead.push(item.tabGroup)
      item.disabled = true;
      item.placeholder = '';
      common.push({label: item.tabGroupName, value: item.tabGroup, tagConfigs: [item]})
    } else {
      common.forEach(res => {
        if (res.value === item.tabGroup) {
          item.disabled = true;
          item.placeholder = '';
          res.tagConfigs.push(item)
        }
      })
    }
  })


  return {
    commmonFormConfig: common.filter(item => item.value === 'THead'),
    tagFormConfig: common.filter(item => item.value !== 'THead'),
    thead
  }
};
